import { Card, Dialog, Stack, TextField as MUITextField, Button as MUIButton } from '@mui/material';
import { ReactElement, useState } from 'react';
import {
  Datagrid,
  FunctionField,
  List,
  TextField,
  useTranslate,
  useRedirect,
} from 'react-admin';
import { DashboardContent } from 'src/layouts/dashboard';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
// 导入数据提供者初始化
import './init';

const View = () => {
  const translate = useTranslate();
  const redirect = useRedirect();
  const [popup, setPopup] = useState<ReactElement>();
  const [overviewUserId, setOverviewUserId] = useState<string>('');
  const [taskCenterUserId, setTaskCenterUserId] = useState<string>('');
  return (
    <PermissionGuard resource="activity-users" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('resource.activityUsers')}
          links={[
            { name: translate('resource.activity') },
            { name: translate('resource.activityUsers') },
          ]}
          action={
            <Stack direction="row" spacing={2} alignItems="center">
              <MUITextField
                label={translate('activity.users.userIdCashbackDashboard')}
                size="small"
                value={overviewUserId}
                onChange={(e) => setOverviewUserId(e.target.value)}
                sx={{ minWidth: 360 }}
              />
              <MUIButton
                variant="contained"
                size="small"
                onClick={() => {
                  if (!overviewUserId) return;
                  redirect(`/activity/userCashbackDashboard?userId=${encodeURIComponent(overviewUserId)}`);
                }}
              >
                {translate('activity.common.go')}
              </MUIButton>
              <MUITextField
                label={translate('activity.users.userIdTaskCenter')}
                size="small"
                value={taskCenterUserId}
                onChange={(e) => setTaskCenterUserId(e.target.value)}
                sx={{ minWidth: 360 }}
              />
              <MUIButton
                variant="contained"
                size="small"
                onClick={() => {
                  if (!taskCenterUserId) return;
                  redirect(`/activity/usertaskCenter?userId=${encodeURIComponent(taskCenterUserId)}`);
                }}
              >
                {translate('activity.common.go')}
              </MUIButton>
            </Stack>
          }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List resource="activity-users" actions={false} empty={false} exporter={false}>
            <Datagrid rowClick={false}>
              <TextField source="userId" label={translate('activity.users.userId')} sortable={false} />
              <TextField source="email" label={translate('activity.common.email')} sortable={false} />
              <TextField source="totalPoints" label={translate('activity.users.totalPoints')} sortable={false} />
              <TextField source="availableCashback" label={translate('activity.users.availableCashback')} sortable={false} />
              <TextField source="totalCashbackClaimed" label={translate('activity.users.totalCashbackClaimed')} sortable={false} />
              <TextField source="pointsToNextTier" label={translate('activity.users.pointsToNextTier')} sortable={false} />
              <TextField source="currentTier" label={translate('activity.users.currentTier')} sortable={false} />
              <TextField source="nextTier" label={translate('activity.users.nextTier')} sortable={false} />
              <TextField source="createdAt" label={translate('activity.users.createdAt')} sortable={false} />
              <TextField source="lastActivityAt" label={translate('activity.users.lastActivityAt')} sortable={false} />
              <FunctionField
                label={translate('activity.common.actions')}
                render={(record: any) => (
                  <MUIButton
                    variant="outlined"
                    size="small"
                    onClick={(e) => {
                      e.preventDefault();
                      if (!record?.userId) return;
                      redirect(`/activity/userCashbackDashboard?userId=${encodeURIComponent(record.userId)}`);
                    }}
                  >
                    {translate('activity.common.overview')}
                  </MUIButton>
                )}
              />
            </Datagrid>
          </List>
        </Card>

        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
